import { render, staticRenderFns } from "./ldSave.vue?vue&type=template&id=6422c88e&scoped=true&"
import script from "./ldSave.vue?vue&type=script&lang=js&"
export * from "./ldSave.vue?vue&type=script&lang=js&"
import style0 from "./ldSave.vue?vue&type=style&index=0&id=6422c88e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6422c88e",
  null
  
)

export default component.exports